/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Section_PricingInputs */

const en_marketing_section_pricing = /** @type {(inputs: Marketing_Section_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

const es_marketing_section_pricing = /** @type {(inputs: Marketing_Section_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios`)
};

const fr_marketing_section_pricing = /** @type {(inputs: Marketing_Section_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifs`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Marketing_Section_PricingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_section_pricing = /** @type {((inputs?: Marketing_Section_PricingInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Section_PricingInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_section_pricing(inputs)
	if (locale === "es") return es_marketing_section_pricing(inputs)
	return fr_marketing_section_pricing(inputs)
});